import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import API from '@resi-media/api-types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/contentdestinations`,
    query: {} as {
      contentScheduleId?: string;
      startRequested?: boolean;
      webEventProfileId?: string;
    },
    responseSchema: API.Central.V3.ContentDestinations.Get.List,
    method: HTTP_METHODS.GET,
  },
};

export const id = {
  [HTTP_METHODS.DELETE]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/contentdestinations/@id`,
    params: {} as { id: string },
    method: HTTP_METHODS.DELETE,
  },
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/contentdestinations/@id`,
    params: {} as { id: string },
    responseSchema: API.Central.V3.ContentDestinations.Get.ById,
    method: HTTP_METHODS.GET,
  },
  [HTTP_METHODS.PATCH]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/contentdestinations/@id`,
    params: {} as { id: string },
    request: {} as API.Central.V3.ContentDestinations.Patch.Request,
    method: HTTP_METHODS.PATCH,
  },
};
